// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3h-1";
export var rateTableServiceLevelDropdown = "_3h-3";
export var rateTableTypeDropdown = "_3h-0";
export var rateTableValueModeDropdown = "_3h-2";